require('./cardBenefitsTelephonesSection.scss');
const PropTypes = require('prop-types');
//@vendor
const React = require('react');
//@commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
//@utilities
const { formatText } = require('core/i18n').i18n;
//@components
const CardBenefit = require('components/cards/cardBenefits/cardBenefit/cardBenefit');

const TRANSLATION_KEY = 'cardBenefitsTelephonesSection-';

class CardBenefitsTelephonesSection extends React.Component {

    buildRows(immTelephones) {
        const { immCard } = this.props;
        return immTelephones.map((item, index) => {
            return (
                <div key={`telephone-item-${index}`} className="col-xs-6 ">
                    <CardBenefit
                        immBenefit={item}
                        immCard={immCard}
                    />
                </div>
            );
        });
    }

    render() {
        const {
            immTelephones,
            isDiamond,
            isPremium,
        } = this.props;
        const rows = this.buildRows(immTelephones);
        let titleTransKey  = 'cardBenefitsTelephonesSection_r42Title';

        if (isDiamond) {
            titleTransKey = 'diamondTitle';
        } else if (isPremium) {
            titleTransKey = 'premiumTitle';
        }

        const title = formatText(`${TRANSLATION_KEY}${titleTransKey}`);

        return (
            <OKSectionBox title={title}>
                <section className="card-benefits-telephones-section__benefits-section row">
                    {rows}
                </section>
            </OKSectionBox>
        );
    }
}


CardBenefitsTelephonesSection.propTypes = {
    immTelephones: PropTypes.object,
    immCard: PropTypes.object,
    isDiamond: PropTypes.bool,
    isPremium: PropTypes.bool,
};

module.exports = CardBenefitsTelephonesSection;
